import {
  Button,
  Grid,
  MenuItem,
  Select,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { ReactComponent as Call } from 'assets/icons/call.svg';
import React, { useContext } from 'react';
import Flag from '../../assets/images/Flag.png';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Box } from '@mui/system';
import Popover from '@mui/material/Popover';
import { makeStyles } from '@mui/styles';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { datacontextsoli } from 'modules/private/BuyerSolicitor/BuyerSolicitor';

function ContactPopOver({
  name,
  surname,
  emailid,
  mobilenum,
  isDialogOpen,
  setDialogOpen,
  anchorEl,
  setAnchorEl,
  solicitor,
  setMessage,
  setChangestab,
}) {
  // variables/states declaration
  const history = useHistory();
  const [value, setValue] = React.useState(10);
  const isScreenSmall = useMediaQuery('(max-width:600px)');
  const currentPage = window.location.pathname;
  const classes = useStyles();
  const { setShowMessage, setMessagedata } = useContext(
    solicitor ? datacontextsoli : datacontext
  );

  // Popup close function
  const handleClose = () => {
    setAnchorEl(null);
    setDialogOpen(false);
  };

  // start call button onclick function
  const startcallmethod = () => {
    setDialogOpen(false);
    if (currentPage.includes('/share')) {
      return window.open(`tel:` + mobilenum);
    }

    localStorage.setItem('dialId', emailid);

    if (currentPage.includes('/solicitor')) {
      setMessage(true);
      setChangestab(true);
      setShowMessage(true);
      setMessagedata({ BuyerSolicitor: true, incomingcall: true });
    } else {
      setShowMessage(true);
      setMessagedata({ incomingcall: true });
    }
  };

  return (
    <Popover
      open={isDialogOpen}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorReference="anchorEl"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        // vertical: CallVendor ? "bottom" : 'top',
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{ className: classes.popoverPaper }}
    >
      <Grid container className={classes.container}>
        <Grid item>
          <Stack flexDirection={'row'} alignItems={'center'}>
            <Call height={16} width={16} className={classes.callIcon} />
            <Typography className={classes.nameText}>
              {' '}
              Call - {name} {surname}{' '}
            </Typography>
          </Stack>
        </Grid>
        <Grid item className={classes.gridItemFlex}>
          <Select
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
            }}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
            className={classes.flagSelectBox}
          >
            <MenuItem value={10} className={classes.flagItem}>
              <img src={Flag} alt="Flag" height={'16px'} width={'32px'}></img>
            </MenuItem>
          </Select>
          <Box size="small" variant="outlined" className={classes.phoneBox}>
            <Typography className={classes.phoneText}> {mobilenum} </Typography>
          </Box>
        </Grid>
        {!isScreenSmall && (
          <Grid item>
            <Typography className={classes.callingMethodTitle}>
              {' '}
              Calling Method
            </Typography>
          </Grid>
        )}
        {!isScreenSmall && (
          <Grid item className={classes.callingOptions}>
            <Box
              size="small"
              variant="contained"
              bgcolor="rgba(108, 42, 210, 0.1)"
              className={classes.retrexBox}
            >
              <Typography className={classes.retrexText}>retreX</Typography>
              <br />
              <Typography className={classes.retrexSubtext}>Default</Typography>
            </Box>
            <Box
              size="small"
              variant="outlined"
              color="success"
              className={classes.mobileBox}
            >
              <Typography className={classes.mobileText}>Mobile</Typography>
            </Box>
          </Grid>
        )}
      </Grid>
      <Grid
        item
        className={`${classes.actionRow} ${
          isScreenSmall ? classes.actionRowMobile : ''
        }`}
      >
        {!isScreenSmall && (
          <Box sx={{ padding: '10px' }}>
            <Typography className={classes.editText}>
              {' '}
              Edit default call method
            </Typography>
          </Box>
        )}
        <Button
          disabled
          variant="contained"
          onClick={() => {
            startcallmethod();
          }}
          className={classes.startCallButton}
        >
          Start Call
        </Button>
      </Grid>
    </Popover>
  );
}

const useStyles = makeStyles(() => ({
  popoverPaper: {
    marginLeft: '-24px',
    marginTop: '20px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column !important',
    justifyContent: 'left',
    padding: '20px 30px',
    gap: '10px',
  },
  nameText: {
    fontFamily: 'Poppins !important',
    fontWeight: 500,
    fontSize: '14px',
    color: 'rgba(102, 102, 102, 1)',
  },
  gridItemFlex: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'left',
    gap: '10px',
  },
  flagSelectBox: {
    height: '42px',
  },
  flagItem: {
    fontFamily: 'Poppins !important',
    fontWeight: 400,
    fontSize: '14px',
    color: '#A1A7A8',
  },
  phoneBox: {
    border: '0.5px solid rgba(76, 164, 214, 1)',
    borderRadius: '5px',
    padding: '10px 39px 10px 10px',
  },
  phoneText: {
    fontFamily: 'Poppins !important',
    fontWeight: 400,
    fontSize: '14px',
    color: 'rgba(102, 102, 102, 1)',
  },
  callingMethodTitle: {
    fontFamily: 'Poppins !important',
    fontWeight: 500,
    fontSize: '14px',
    color: 'rgba(102, 102, 102, 1)',
  },
  callingOptions: {
    display: 'flex',
    flexDirection: 'row',
    gap: '25px',
  },
  retrexBox: {
    padding: '5px 39px',
    borderRadius: '5px',
    textAlign: 'center',
    backgroundColor: 'rgba(108, 42, 210, 0.1)',
  },
  retrexText: {
    fontFamily: 'Poppins !important',
    fontWeight: 400,
    fontSize: '14px',
    color: 'rgba(108, 42, 210, 1)',
  },
  retrexSubtext: {
    fontFamily: 'Poppins !important',
    fontWeight: 400,
    fontSize: '8px',
    color: 'rgba(108, 42, 210, 1)',
  },
  mobileBox: {
    padding: '10px 39px',
    border: '1px solid rgba(17, 35, 71, 0.1)',
    borderRadius: '5px',
  },
  mobileText: {
    fontFamily: 'Poppins !important',
    fontWeight: 400,
    fontSize: '14px',
  },
  actionRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left',
    gap: '20px',
    padding: '20px',
  },
  actionRowMobile: {
    justifyContent: 'center',
  },
  editText: {
    fontFamily: 'Poppins !important',
    fontWeight: 400,
    fontSize: '10px',
    color: 'rgba(76, 164, 214, 1)',
    padding: '10px',
  },
  startCallButton: {
    fontFamily: 'Poppins !important',
    fontWeight: 400,
    fontSize: '14px',
    color: 'white',
    textTransform: 'none',
    padding: '10px 39px',
  },
  callIcon: {
    marginBottom: '-3px',
    marginRight: '2px',
  },
}));

export default ContactPopOver;
